import { render, staticRenderFns } from "./add_parc.vue?vue&type=template&id=a9503304&scoped=true"
import script from "./add_parc.vue?vue&type=script&lang=js"
export * from "./add_parc.vue?vue&type=script&lang=js"
import style0 from "./add_parc.vue?vue&type=style&index=0&id=a9503304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9503304",
  null
  
)

export default component.exports